// src/components/Header/index.jsx
import React from 'react';
import { Layout, Menu, Avatar, Button } from 'antd';
import { HomeOutlined, BookOutlined, UserOutlined, EditOutlined, LoginOutlined } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import './index.css';

const { Header } = Layout;

const BlogHeader = () => {
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('userToken');
  const user = JSON.parse(localStorage.getItem('userInfo') || '{}');

  const handleLogout = () => {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userInfo');
    navigate('/auth');
  };

  return (
    <Header className="blog-header">
      <div className="header-logo">
        <h1>
          <span className="chinese-seal">印</span>
          如果文物会说话
        </h1>
      </div>
      
      <Menu theme="light" mode="horizontal" className="nav-menu">
        <Menu.Item key="home" icon={<HomeOutlined />}>
          <Link to="/">首页</Link>
        </Menu.Item>
        <Menu.Item key="archive" icon={<BookOutlined />}>
          <Link to="/archive">文物归档</Link>
        </Menu.Item>
        <Menu.Item key="about" icon={<UserOutlined />}>
          <Link to="/about">我的</Link>
        </Menu.Item>
        {isLoggedIn && (
          <Menu.Item key="write" icon={<EditOutlined />}>
            <Link to="/write">写文物</Link>
          </Menu.Item>
        )}
      </Menu>

      <div className="user-section">
        {isLoggedIn ? (
          <>
            <Avatar src={user.avatar} icon={<UserOutlined />} />
            <span className="username">{user.name}</span>
            <Button type="text" onClick={handleLogout}>登出</Button>
          </>
        ) : (
          <Button type="primary" icon={<LoginOutlined />} onClick={() => navigate('/auth')}>
            登录
          </Button>
        )}
      </div>
    </Header>
  );
};

export default BlogHeader;